import axios, { HttpStatusCode } from "axios";
import { StatusMessageResponse } from "../../../common/interfaces/status-message-response";

export async function processEmitPurchaseOrder(data: Array<string>, token: string): Promise<StatusMessageResponse> {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_URL+'/ordemcompra-emit/processar', 
        {
          ids: data,
        }, 
        {
            headers: {
                Authorization: 'Bearer ' + token
            }
        }
      );
  
      const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
      return res;
    } catch (error: any) {
      return {
        statusCode: HttpStatusCode.InternalServerError,
        message: error.response.data.message,
      }
    }
}